import { Link } from "react-router-dom";

import { useHideOnScroll } from "@/hooks/useHideOnScroll";
import { useScrolledPast } from "@/hooks/useScrolledPast";
import { cn } from "@/lib/cn";

import { LandingButton } from "@/components/landing/LandingButton";
import { Logo } from "@/components/ui/Logo";

const NAV_LINKS = [
  { label: "О проекте", href: "#about" },
  { label: "Безопасность", href: "#security" },
  { label: "Модель оплаты", href: "#pricing" },
  { label: "Подключение", href: "#cta" },
  { label: "FAQ", href: "#faq" },
];

export const LANDING_HEADER_HEIGHT = "5.625rem";
const LANDING_HEADER_HEIGHT_PX = 90;

export const Header = () => {
  const isHidden = useHideOnScroll({ offset: LANDING_HEADER_HEIGHT_PX });
  const hasLeftHero = useScrolledPast();

  return (
    <header
      className={cn(
        "fixed top-0 right-0 left-0 z-50 min-w-[22.5rem] bg-white",
        "transition-transform duration-300 ease-out will-change-transform motion-reduce:transition-none",
        isHidden && "-translate-y-full"
      )}
      style={{ height: LANDING_HEADER_HEIGHT }}
    >
      <div className="landing-container flex h-full items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            aria-label="Spider"
          >
            <Logo
              iconClassName="landing-logo text-landing-ink size-5.5"
              textClassName="text-landing-ink text-[1.375rem] leading-none [text-box:trim-both_cap_alphabetic]"
            />
          </Link>

          <nav className="hidden items-center gap-5 lg:flex">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={cn(
                  "text-trim text-landing-nav text-[0.875rem] leading-[1.2] font-semibold tracking-[0.02em] whitespace-nowrap",
                  "hover:text-landing-ink transition-colors duration-300"
                )}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <LandingButton
            variant="dark"
            asChild
            className={cn(
              "transition-[opacity,transform] duration-300",
              !hasLeftHero && "max-md:pointer-events-none max-md:-translate-y-2 max-md:opacity-0"
            )}
          >
            <Link to="/register">Запустить Spider</Link>
          </LandingButton>
          <LandingButton
            variant="light"
            asChild
            className="max-md:hidden"
          >
            <Link to="/register">Попробовать демо</Link>
          </LandingButton>
        </div>
      </div>
    </header>
  );
};
